<h3>{{ premiumDeterminingFactor.factorDescription }} wijzigen</h3>
<form (ngSubmit)="onSubmit()" [formGroup]="form">
    <wuc-form-field>
        <wuc-form-field-label>
            {{ premiumDeterminingFactor.factorDescription }}
        </wuc-form-field-label>
        <wuc-select id="premium_determining_factor_value_{{ premiumDeterminingFactor.formatCode }}"
                    formControlName="factorValue">
            <wuc-select-option></wuc-select-option>
            <wuc-select-option *ngFor="let inhoud of options" [value]="inhoud.inhoud_id">
                {{ inhoud.inhoud_omschrijving }}</wuc-select-option>
        </wuc-select>
    </wuc-form-field>
    <wuc-form-field>
        <wuc-form-field-label>Ingangsdatum</wuc-form-field-label>
        <wuc-input-date-picker formControlName="startDate" id="ingangsdatum" [minDate]="minDate"></wuc-input-date-picker>
    </wuc-form-field>
    <wuc-balloon backgroundStyle="secondary" padding="medium" [hasCloseIcon]="false" *ngIf="errors?.length">
        <wuc-list icon="cross">
            <ng-container *ngFor="let error of errors">
                <wuc-list-item>{{ error.message }}</wuc-list-item>
            </ng-container>
        </wuc-list>
    </wuc-balloon>
    <wuc-form-field>
        <wuc-form-field-label></wuc-form-field-label>
        <wuc-button [isSubmitButton]="true" [isFullWidth]="true" type="primary" [disabled]="isDisabled">
            Wijzigen
        </wuc-button>
    </wuc-form-field>
</form>
